import { type UpdateEmployeeRequestDto } from '@/api/generated/models/update-employee-request-dto';
import { type MyProfileModalFormModel } from '@/components/company/companyUserModal/model/myProfileModalForm.model.ts';
import { type SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export const companyEmployeeToBackendMapper = (
  data: Required<MyProfileModalFormModel>,
): UpdateEmployeeRequestDto => ({
  firstName: data.firstName,
  lastName: data.lastName,
  locationId: data.location.value,
  operatingLocations:
    data.operatingLocations
      ?.filter(item => item?.value != null)
      .map(entry => (entry as SelectSearchOptionModel<number>).value) ?? [],
  phoneNumber: data.phoneNumber,
  role: data.role.value,
  status: data.status.value,
});
